<img src="assets/cards/{{image}}.png" alt="{{text}}" />
